export enum MAIL_PLACEHOLDERS {
  USER_NAME = '%userName%',
  PORTAL = '%portal%',
  URL = '%portalUrl%',
  USER_EMAIL = '%userEmail%',
  USER_PASSWORD = '%password%'
}
